<template>
  <div v-if="!loading">
    <section class='container-fluid'>
      <div class="row">
        <account-graph
          v-for="account in accounts"
          :key="account.uuid"
          :account-uuid="account.uuid" 
        />
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import {mapActions, mapState} from "pinia";
import useSettingsStore from "@/stores/settings.store.js";
import * as companyService from '@/services/company.service.js';
import AccountGraph from "@/components/Dashboard/AccountGraph.vue";

const settings = useSettingsStore();
const route = useRoute();

const loading = ref(false);
const stats = ref([]);
const company = ref(null);
const accounts = ref([]);


async function init() {
  settings.setTitle('Dashboard');

  // Let's do them in parallel to keep good performance
  let [companyRes, accountsRes] = await Promise.all([
    companyService.get(route.params.company),
    companyService.getAccounts(route.params.company)
  ]);

  company.value = companyRes;
  accounts.value = accountsRes; 

  settings.setSubtitle(company.value.full_name)
}

init();


</script>

<style>
</style>
